<div [formGroup]="form">
    <input id="addInitiative" type="checkbox" lgStyledCheckbox formControlName="addInitiative" />
    <label>{{ ".AddInitiativeInfo" | lgTranslate }}</label>
</div>
<div class="form-group form-group--buttons">
    <div class="form-row">
        <lg-button
            buttonClass="button--primary"
            [textLc]="'.CorrectInputBtn'"
            [isDisabled]="!addInitiative"
            (click)="correctValue()"
        >
        </lg-button>
        <lg-button buttonClass="button--secondary" [textLc]="'FW.OK'" (click)="saveOrDefault()">
        </lg-button>
    </div>
</div>
